import type { SupportedChainName } from "../../types/base"
import {
  isValidBlockchainEnumKey,
  reverseAssetNetworkAdapter,
} from "../adapters"
import { allAvailableChains } from "../blockchain"

/**
 * Returns the `SupportedChainName[]` for chains the scanner can classify
 * addresses against. Excludes `near_intents` (virtual destination with no
 * address shape). Used by both the home-screen `resolveScan` flow and the
 * contact-modal `classifyScannedAddress` call site.
 *
 * Keeping this in one place ensures the two scanners can never drift.
 */
export function getScannableChains(): SupportedChainName[] {
  return Object.keys(allAvailableChains())
    .filter(isValidBlockchainEnumKey)
    .map((k) => reverseAssetNetworkAdapter[k])
}
